module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_instagram-7f18daedad8602712aa1e9c0db2ca5f8.svg";